import apiService from './apiService';
import apiServiceNew from './apiService.new';


export default (function() {
	var versionFilePath = '/versionFile';
	var parseOptions = {
		'datetimes': ['CreateDate']
	};


	function doGet(url) {
		return apiService.get(url)
			.then(function(data) {
				var res = data.items;

				// parse data
				if (res instanceof Array) {
					for (let i = 0; i < res.length; i++) {
						apiService.parse(res[i], parseOptions);
					}
				}
				return res;
			});

	}

	function fetch(mediaId, version) {
		return doGet(versionFilePath + '?mediaId=' + mediaId + '&version=' + version);
	}

	function fetchByType(mediaId, version, type) {
		return doGet(versionFilePath + '?mediaId=' + mediaId + '&version=' + version + '&type=' + type);
	}

	function shared(token, mediaId) {
		var url = versionFilePath + '/' + token + '/shared'
			+ apiService.paramsToQuery({
				mediaId: mediaId
			});

		return apiService.get(url);
	}

	// TODO: migrate all emthods to the apiServiceNew;

	function create(file) {
		return apiServiceNew.post(versionFilePath, file);
	}

	function deleteFile(id) {
		return apiServiceNew.delete(`${versionFilePath}/${id}`);
	}

	const getDownloadUrl = (id, mediaName) => {
		return `${apiService.rootUrl()}${versionFilePath}/${id}/file${mediaName ? `?mediaName=${mediaName}` : ''}`;
	};

	return {
		fetch: fetch,
		fetchByType: fetchByType,
		shared: shared,
		create,
		delete: deleteFile,
		getDownloadUrl: getDownloadUrl
	};
})();